import React, { memo } from 'react'
import Carousel from 'nuka-carousel'
import DisplayComponent from './DisplayComponent'

const DisplayCarousel = memo(function content({displays, deviceCode, autoplay, deviceId, showDeviceId, displayPosition, deviceRotationTime}) {
  return (
    <Carousel
      cellAlign="center"
      autoplay={autoplay}
      autoplayInterval={deviceRotationTime}
      withoutControls
      pauseOnHover={false}
      speed={1}

      style={{
        width:"102%"
      }}

    >
      {displays.map((display) => <DisplayComponent
        display={display}
        showDeviceId={showDeviceId}
        deviceCode={deviceCode}
        deviceId={deviceId}
        displayPosition={displayPosition}
        qrCodeIndex={display.position}
      />)}

    </Carousel>
  )
});


export default DisplayCarousel